import { useSelector } from "react-redux";

const useStore = () => useSelector(s => s);

export default useStore;